import * as bootstrap from 'bootstrap';

const mySubs = document.getElementById('subscribe'),
  myErrorHandler = document.getElementById('errorMessage'),
  myInput = document.getElementById('exampleInputEmail1'),
  regEx =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
mySubs.addEventListener('click', () => {
  let typed = myInput.value;
  if (typed === '') {
    myErrorHandler.textContent = 'The Email Field Cannot be Empty';
    myErrorHandler.style.color = 'red';
  } else if (!typed.match(regEx)) {
    myErrorHandler.textContent = 'Please Enter a Valid Email Address';
    myErrorHandler.style.color = 'red';
  } else if (typed.match(regEx)) {
    myErrorHandler.textContent = 'Email is Valid';
    myErrorHandler.style.color = '#73D06F';
  }
});

document.addEventListener('keyup', (event) => {
  let typed = myInput.value;
  if (event.keyCode === 13) {
    console.log('pressed enter');
    if (typed === '') {
      myErrorHandler.textContent = 'The Email Field Cannot be Empty';
      myErrorHandler.style.color = 'red';
    } else if (!typed.match(regEx)) {
      myErrorHandler.textContent = 'Please Enter a Valid Email Address';
      myErrorHandler.style.color = 'red';
    } else if (typed.match(regEx)) {
      myErrorHandler.textContent = 'Email is Valid';
      myErrorHandler.style.color = '#73D06F';
    }
  }
});
